import { useState } from 'react';
import { Star } from 'lucide-react';

interface RatingCellProps {
  value: number | null;
  onChange: (value: number | null) => void;
  readOnly?: boolean;
}

export function RatingCell({ value, onChange, readOnly }: RatingCellProps) {
  const [hoveredStar, setHoveredStar] = useState<number | null>(null);
  
  const rating = value || 0;
  const displayRating = hoveredStar !== null ? hoveredStar : rating;

  const handleClick = (star: number) => {
    if (readOnly) return;
    
    // Se clicar na mesma estrela, limpa o rating
    if (star === rating) {
      onChange(null);
    } else {
      onChange(star);
    }
  };

  return (
    <div
      className="flex items-center gap-1"
      onMouseLeave={() => setHoveredStar(null)}
    >
      {[1, 2, 3, 4, 5].map((star) => {
        const isFilled = star <= displayRating;
        
        return (
          <Star
            key={star}
            className={`w-5 h-5 transition-all ${
              readOnly ? 'cursor-default' : 'cursor-pointer'
            } ${
              isFilled
                ? 'fill-yellow-400 text-yellow-400'
                : 'fill-none text-gray-300'
            } ${
              !readOnly && hoveredStar !== null && star <= hoveredStar
                ? 'scale-110'
                : ''
            }`}
            onMouseEnter={() => !readOnly && setHoveredStar(star)}
            onClick={() => handleClick(star)}
          />
        );
      })}
      
      {rating > 0 && (
        <span className="ml-2 text-sm text-gray-600">
          {rating}/5
        </span>
      )}
    </div>
  );
}
